import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';

import { FormModule } from '@shared/components/form';

import { SelectFieldsModule } from '../select-fields';
import { TextModule } from '../text';
import { TooltipModule } from '../tooltip';
import { SettingNumberTextboxComponent } from './components/setting-number-textbox';
import { SettingSelectComponent } from './components/setting-select';
import { SettingTextComponent } from './components/setting-text';
import { SettingToggleComponent } from './components/setting-toggle/setting-toggle.component';

@NgModule({
  declarations: [SettingTextComponent, SettingToggleComponent, SettingNumberTextboxComponent, SettingSelectComponent],
  imports: [
    CommonModule,
    MatSlideToggleModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    SelectFieldsModule,
    FormModule,
    TooltipModule,
    TextModule,
  ],
  exports: [SettingTextComponent, SettingToggleComponent, SettingNumberTextboxComponent, SettingSelectComponent],
})
export class SettingsModule {}
